import React, { useState, useEffect } from "react";
import { Table, Checkbox, message, Pagination } from "antd";
import { useBranchList } from "../../../app/hooks/branchList";
import { DBFilterCheckboxArea, DBFilterWrapper, DBTableExcelBtn } from "../DB/styles";
import BranchEmployeeAdd from "../../components/Add/BranchEmployeeAdd";
import BranchEmployeeEdit from "../../components/Edit/BranchEmployeeEdit";
import styled from "styled-components";
import API from "../../../utils/api";
import { useToken } from "../../../app/hooks";
import { Icon } from "../Main/styles";
import { FaRegFileExcel } from "react-icons/fa";
import { CheckboxUnit, DBTableBtn } from "../Customer/styles";
import { BranchEdit } from "../../components/Edit/BranchEdit";
import { BranchPaydaEdit } from "../../components/Edit/BranchPaydaEdit";
import { useIsMobile } from "../../components/IsMobile";
import { useMyInfo } from "CRM/hooks/GetMyInfo";

export const BranchTable = ({ mutate, resList, teamList, branchList, respon, team, branch, name, address, depositAt, withdrawAt, bList }) => {
	const IsMobile = useIsMobile();
	const [scrollPosition, setScrollPosition] = useState(0);
	const [selectedRows, setSelectedRows] = useState<number[]>([]);
	const [isAllChecked, setIsAllChecked] = useState(false);
	const [userId, setUserId] = useState(null);
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);

	const { data: token } = useToken();
	const { myInfo } = useMyInfo();
	const {
		data: customerList,
		total,
		mutate: customerListMutate,
	} = useBranchList(
		false,
		respon == "" ? "" : resList?.find((it) => it.name == respon)?.id,
		team == "" ? "" : teamList?.find((it) => it.name == team)?.id,
		branch == "" ? "" : bList?.find((it) => it.id == branch)?.id,
		name,
		address,
		depositAt?.[0] == null ? "" : `${depositAt?.[0]?.format("YYYY-MM-DD") + "~" + depositAt?.[1]?.format("YYYY-MM-DD")}`,
		withdrawAt?.[0] == null ? "" : `${withdrawAt?.[0]?.format("YYYY-MM-DD") + "~" + withdrawAt?.[1]?.format("YYYY-MM-DD")}`,
		page,
		pageSize
	);

	useEffect(() => {
		if (!userId && IsMobile) {
			window.scrollTo({ top: scrollPosition, behavior: "smooth" });
		} else if (userId && IsMobile) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			setScrollPosition(window.scrollY);
		}
	}, [userId]);

	useEffect(() => {
		const allSelected = customerList?.length > 0 && customerList?.every((it) => selectedRows?.includes(it.id));
		setIsAllChecked(allSelected);
	}, [selectedRows, customerList]);

	const handleSelectAllChange = (e) => {
		setIsAllChecked(e.target.checked);
		const ids = customerList?.map((db) => db.id);
		setSelectedRows(e.target.checked ? [...selectedRows, ...ids] : []);
	};

	const handleCheckboxChange = (e, id) => {
		if (e.target.checked) {
			setSelectedRows([...selectedRows, id]);
		} else {
			setSelectedRows(selectedRows?.filter((rowId) => rowId !== id));
		}
	};

	const clickDelete = () => {
		const shouldEdit = window.confirm(`선택한 내역을 삭제하시겠습니까?`);
		if (shouldEdit) {
			if (selectedRows?.length == 0) {
				message.error("선택한 내역이 없습니다.");
			} else {
				API.post("/branch/list/delete", token + "", {
					ids: selectedRows,
				})
					.then((res: any) => {
						if (res.result.success) {
							message.success("삭제되었습니다.");
							customerListMutate();
						}
					})
					.catch((err: any) => {});
			}
		}
	};

	const excelDownAll = () => {
		const shouldEdit = window.confirm(`전체 내역을 다운받으시겠습니까?`);
		if (shouldEdit) {
			API.post(
				"/branch/list/excel?page=1&maxData=99999999" +
					"&teamId=" +
					(team == "" ? "" : teamList?.find((it) => it.name == team)?.id) +
					"&branchId=" +
					(branch == "" ? "" : bList?.find((it) => it.id == branch)?.id) +
					"&responsibilityId=" +
					(respon == "" ? "" : resList?.find((it) => it.name == respon)?.id) +
					"&depositedAt=" +
					(depositAt?.[0] === null
						? ""
						: `${depositAt?.[0]?.format("YYYY-MM-DD") + "~" + depositAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&withdrawalAt=" +
					(withdrawAt?.[0] == null
						? ""
						: `${withdrawAt?.[0]?.format("YYYY-MM-DD") + "~" + withdrawAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&customerName=" +
					name +
					"&address=" +
					address,
				token + "",
				{
					ids: [],
				}
			)
				.then((res: any) => {
					if (res.result.success) {
						window.open(res.result.result.link, "_blank");
					}
				})
				.catch((err: any) => {});
		}
	};

	const excelDownSelect = () => {
		const shouldEdit = window.confirm(`선택한 내역 목록을 다운받으시겠습니까?`);
		if (shouldEdit) {
			API.post(
				"/branch/list/excel?page=1&maxData=99999999" +
					"&teamId=" +
					(team == "" ? "" : teamList?.find((it) => it.name == team)?.id) +
					"&branchId=" +
					(branch == "" ? "" : bList?.find((it) => it.id == branch)?.id) +
					"&responsibilityId=" +
					(respon == "" ? "" : resList?.find((it) => it.name == respon)?.id) +
					"&depositedAt=" +
					(depositAt?.[0] === null
						? ""
						: `${depositAt?.[0]?.format("YYYY-MM-DD") + "~" + depositAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&withdrawalAt=" +
					(withdrawAt?.[0] == null
						? ""
						: `${withdrawAt?.[0]?.format("YYYY-MM-DD") + "~" + withdrawAt?.[1]?.format("YYYY-MM-DD")}`) +
					"&customerName=" +
					name +
					"&address=" +
					address,
				token + "",
				{
					ids: selectedRows,
				}
			)
				.then((res: any) => {
					if (res.result.success) {
						window.open(res.result.result.link, "_blank");
					}
				})
				.catch((err: any) => {});
		}
	};

	const handleTableChange = (pagination) => {
		setPage(pagination.current);
		setPageSize(pagination.pageSize);
	};

	const mobileColumns = [
		{
			dataIndex: "checkbox",
			title: <Checkbox checked={isAllChecked} onChange={handleSelectAllChange} />,
			render: (value, data) => {
				return (
					<div className="checkbox">
						<Checkbox
							style={{ justifyContent: "center", display: "flex" }}
							checked={selectedRows?.includes(data.id)}
							key={data?.id}
							onChange={(e) => handleCheckboxChange(e, data?.id)}
						/>
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "페이다 입출금",
			render: (value, data) => {
				return (
					<>
						<div className="date" style={{ justifyContent: "flex-start", display: "flex" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>날짜: </p> {data?.date}
						</div>
						<div
							className="email"
							onClick={() => setUserId(data?.id)}
							style={{ color: "#437eff", cursor: "pointer", justifyContent: "flex-start", display: "flex" }}
						>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>이메일: </p>
							{data?.email}
						</div>
						<div className="money" style={{ justifyContent: "flex-start", display: "flex" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>금액: </p> $
							{parseFloat(data?.usdAmount).toLocaleString()}
						</div>
						<div className="name" style={{ justifyContent: "flex-start", display: "flex" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>이름: </p>
							{data?.name}
						</div>
						<div className="ib" style={{ justifyContent: "flex-start", display: "flex" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>IB: </p>
							{data?.ib}
						</div>
						<div className="method" style={{ justifyContent: "flex-start", display: "flex" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>거래수단: </p> {data?.method}
						</div>
						<div className="krwAmount" style={{ justifyContent: "flex-start", display: "flex" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>원화: </p>
							{parseFloat(data?.krwAmount).toLocaleString()}
						</div>
						<div className="type" style={{ justifyContent: "flex-start", display: "flex" }}>
							<p style={{ marginRight: 5, fontWeight: "bold" }}>입/출금: </p>
							{data?.type == 1 ? "입금" : "출금"}
						</div>
					</>
				);
			},
		},
	];

	const columns = [
		{
			dataIndex: "checkbox",
			title: <Checkbox checked={isAllChecked} onChange={handleSelectAllChange} />,
			render: (value, data) => {
				return (
					<div className="checkbox">
						<Checkbox
							style={{ justifyContent: "center", display: "flex" }}
							checked={selectedRows?.includes(data.id)}
							key={data?.id}
							onChange={(e) => handleCheckboxChange(e, data?.id)}
						/>
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "날짜",
			render: (value, data) => {
				return (
					<div className="date" style={{ justifyContent: "center", display: "flex" }}>
						{data?.date}
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "이메일",
			render: (value, data) => {
				return (
					<div
						className="email"
						onClick={() => setUserId(data?.id)}
						style={{
							color: "#437eff",
							textDecoration: "underline",
							cursor: "pointer",
							justifyContent: "center",
							display: "flex",
						}}
					>
						{data?.email}
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "금액",
			render: (value, data) => {
				return (
					<div className="money" style={{ justifyContent: "flex-end", display: "flex" }}>
						${parseFloat(data?.usdAmount).toLocaleString()}
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "이름",
			render: (value, data) => {
				return (
					<div className="name" style={{ justifyContent: "center", display: "flex" }}>
						{data?.name}
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "IB",
			render: (value, data) => {
				return (
					<div className="ib" style={{ justifyContent: "center", display: "flex" }}>
						{data?.ib}
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "거래수단",
			render: (value, data) => {
				return (
					<div className="method" style={{ justifyContent: "center", display: "flex" }}>
						{data?.method}
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "원화",
			render: (value, data) => {
				return (
					<div className="krwAmount" style={{ justifyContent: "flex-end", display: "flex" }}>
						{parseFloat(data?.krwAmount).toLocaleString()}
					</div>
				);
			},
		},
		{
			dataIndex: "",
			title: "입/출금",
			render: (value, data) => {
				return (
					<div className="type" style={{ justifyContent: "center", display: "flex" }}>
						{data?.type == 1 ? "입금" : "출금"}
					</div>
				);
			},
		},
	];

	return (
		<DBFilterWrapper>
			<DBFilterCheckboxArea>
				<div style={{ display: "flex", gap: 10, justifyContent: "space-between", width: "100%" }}>
					{myInfo.master || process.env.REACT_APP_URL?.includes("ccl") ? (
						<>
							{IsMobile ? (
								<CheckboxUnit>
									<DBTableBtn border="green" color="green" onClick={excelDownAll} IsMobile={IsMobile}>
										엑셀다운로드
									</DBTableBtn>
									<DBTableBtn border="green" color="green" onClick={excelDownSelect} IsMobile={IsMobile}>
										선택 다운로드
									</DBTableBtn>
									<DBTableBtn
										border="red"
										color="red"
										onClick={clickDelete}
										style={{ backgroundColor: "#f93e3e", color: "#fff", marginLeft: 20 }}
										IsMobile={IsMobile}
									>
										선택 삭제
									</DBTableBtn>
								</CheckboxUnit>
							) : (
								<CheckboxUnit>
									<DBTableExcelBtn onClick={excelDownAll}>
										<Icon>
											<FaRegFileExcel />
										</Icon>
										엑셀다운로드
									</DBTableExcelBtn>
									<DBTableExcelBtn onClick={excelDownSelect}>
										<Icon>
											<FaRegFileExcel />
										</Icon>
										선택 다운로드
									</DBTableExcelBtn>
								</CheckboxUnit>
							)}

							{!IsMobile && (
								<DBTableExcelBtn onClick={clickDelete} style={{ backgroundColor: "#f93e3e", color: "#fff" }}>
									선택 삭제
								</DBTableExcelBtn>
							)}
						</>
					) : (
						<></>
					)}
				</div>
			</DBFilterCheckboxArea>
			<Table
				columns={IsMobile ? mobileColumns : columns}
				dataSource={customerList}
				bordered={true}
				pagination={{
					current: page,
					pageSize: pageSize,
					total: total,
				}}
				onChange={handleTableChange}
			/>

			{userId !== null && <BranchPaydaEdit userId={userId} setUserId={setUserId} mutate={customerListMutate} />}
		</DBFilterWrapper>
	);
};

export default React.memo(BranchTable);

const Container = styled.div``;
